angular.module 'modulesSettings', [
  'review.setting'
  'product.setting'
  'align.setting'
  'valign.setting'
  'form.setting'
  'subscribeForm.setting'
  'formfields.setting'
  'subscribeFormfields.setting'
  'sliderfields.setting'
  'border.setting'
  'colorpicker.setting'
  'padding.setting'
  'margin.setting'
  'shadow.setting'
  'radius.setting'
  'height.setting'
  'width.setting'
  'size.setting'
  'image.setting'
  'uploader.setting'
  'modalWysiwyg.setting'
  'sizeSelect.setting'
  'card.setting'
  'name.setting'
  'galleryfields.setting'
  'navigationfields.setting'
  'map.setting'
  'bgfields.setting'
  'socialfields.setting'
  'news.setting'
  'buttonActions.setting'
  'colors.setting'
  'timer.setting'
  'slidersize.setting'
  'gradient.setting'
  'listfields.setting'
  'photolibrary.setting'
  'photolibrary.controller'
  'tablefields.setting'
  'sitebg.setting'
  'hover.setting'
  'iconSelector.setting'
  'facebookComment.setting'
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/main.coffee